import baseAPI from './axiosApi'
import qs from 'qs'

const api={
    login:'/sys/login',
    current:'/api-u/user/current?access_token=',
    logout:'/sys/logout?access_token=',
    edit:'/api-u/users/password',
}

export function Login (parameter) {
    return baseAPI.axiosData(api.login,'post',qs.stringify(parameter))
}
export function Current (parameter) {
    return baseAPI.axiosData(api.current+parameter,'get')
}
export function Logout (parameter) {
    return baseAPI.axiosData(api.logout+parameter,'get')
}
export function Edit (parameter) {
    return baseAPI.axiosData(api.edit,'put',qs.stringify(parameter))
}